import { tv } from 'tailwind-variants';

export const header = tv({
  slots: {
    base: 'flex w-full justify-between bg-gray-800 h-fit p-4',
    nav: 'flex items-center justify-between w-full text-sm text-gray-400 h-fit',
  },
  variants: {
    isExport: {
      true: {},
      false: {},
    },
    sidebarOpen: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      isExport: true,
      sidebarOpen: true,
      className: {
        base: '',
        nav: '',
      },
    },
    {
      isExport: false,
      sidebarOpen: true,
      className: {
        base: '',
        nav: '',
      },
    },
    {
      isExport: false,
      sidebarOpen: false,
      className: {
        base: '',
        nav: '',
      },
    },
  ]
}
);
